import SmallPlusIconPath from "@ingka/ssr-icon/paths/plus-small";
export default SmallPlusIconPath;
